<template>
    <div
        v-if="!props.frontend || (chat && chat.status !== 'minimized')"
        class="chat-wrapper"
        :class="[props.boxed ? 'chat-wrapper--boxed' : '']"
        @click="removeNotifications"
    >
        <div
            class="chat-header"
            :class="[
                !props.frontend && !chat ? 'chat-header--closed' : '',
                !props.frontend && chat && chat.status === 'closed' ? 'chat-header--closed' : '',
                !props.frontend && chat && chat.status === 'active' ? 'chat-header--opened' : '',
                !props.frontend && chat && chat.status === 'idle' ? 'chat-header--idle' : '',
                !props.frontend && chat && chat.status === 'minimized' ? 'chat-header--minimized' : '',
                props.frontend ? 'chat-header--frontend' : '',
            ]"
        >
            <span v-if="!props.frontend" class="cursor-pointer" @click="editLabel">
                <span v-if="labelEditing">
                    <input v-model="chat.label" class="bg-white/20" @change="updateLabel" />
                </span>
                <span v-else-if="chat">
                    {{ chat.label }}
                </span>
            </span>

            <!-- Responding info -->
            <div v-if="props.frontend && chat.responding" class="chat-header-aligned">
                <div class="chat-responding">
                    <div class="chat-responding-preview">
                        <div class="chat-responding-avatar-wrapper">
                            <img :src="chat.responding.avatar" class="chat-responding-avatar" />
                        </div>
                    </div>
                    <div class="chat-responding-info">
                        <p class="chat-responding-info-name">{{ chat.responding.name }}</p>
                        <p>{{ chat.responding.verbose }}</p>
                    </div>
                </div>
            </div>
            <div v-else-if="props.frontend">
                <div>Chat</div>
                <div class="chat-responding-info-offline">Právě jsme offline</div>
            </div>

            <div class="chat-header-button-wrapper-left">
                <button
                    v-if="!props.frontend && chat && chat.status === 'active'"
                    type="button"
                    class="chat-header-button"
                    @click="idleChat"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="chat-header-icon"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                    </svg>
                </button>
                <button
                    v-if="!props.frontend && chat && chat.status === 'idle'"
                    type="button"
                    class="chat-header-button"
                    @click="reopenChat"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="chat-header-icon"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
                        />
                    </svg>
                </button>
            </div>

            <div class="chat-header-button-wrapper-right">
                <button
                    v-if="!props.frontend && chat && chat.status !== 'closed'"
                    type="button"
                    class="chat-header-button"
                    @click="closeChat"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="chat-header-icon"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                </button>
                <button
                    v-if="!props.frontend && chat && chat.status === 'closed'"
                    type="button"
                    class="chat-header-button"
                    @click="reopenChat"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="chat-header-icon"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
                        />
                    </svg>
                </button>
                <button v-if="props.frontend" type="button" class="chat-header-button" @click="minimizeChat">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="chat-header-icon"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                    </svg>
                </button>
            </div>
        </div>

        <!-- Chat info -->
        <div v-show="!props.frontend" class="chat-info">
            <div class="chat-info-content">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="chat-info-icon"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
                    />
                </svg>

                <span>
                    <span v-if="chat && chat.info && chat.info.platform"> {{ chat.info.platform }}, </span>
                    <span v-if="chat && chat.info && chat.info.browser">
                        {{ chat.info.browser }}
                        {{ chat.info.version }}
                    </span>
                </span>
            </div>
            <div v-if="chat && chat.info.page_title && chat.info.page_url" class="chat-info-content">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="chat-info-icon"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
                    />
                </svg>

                <a :href="chat.info.page_url" target="_blank" class="chat-info-link">
                    {{ chat.info.page_title }}
                </a>
            </div>
        </div>

        <!-- Chat content -->
        <div
            ref="chatContent"
            class="chat-content"
            :class="[chat && chat.status === 'active' ? 'chat-content--active' : 'chat-content--inactive']"
        >
            <chat-group
                v-for="(group, groupIndex) in grouped"
                :key="groupIndex"
                :group="group"
                :frontend="props.frontend"
            ></chat-group>
        </div>

        <!-- Chat form -->
        <div
            v-show="
                (chat && (chat.status === 'active' || chat.status === 'idle' || chat.status === 'minimized')) ||
                props.frontend
            "
            class="chat-form"
        >
            <div class="chat-relative">
                <div v-if="showEmojiSelection" key="emoji-selection" ref="emojiSelection" class="chat-emoji-window">
                    <ul class="chat-emoji-grid">
                        <li v-for="emoji in emojis" :key="emoji" class="chat-emoji-pick" @click="addEmoji(emoji)">
                            {{ emoji }}
                        </li>
                    </ul>
                </div>
            </div>

            <form @submit.prevent="submit">
                <input
                    v-model="form.message"
                    class="chat-form-input"
                    type="text"
                    placeholder="Napište zprávu"
                    @click="updateCurrentTypingInfo"
                    @keydown="updateCurrentTypingInfo"
                />

                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                    class="chat-emoji-button"
                    @click="showEmojiSelection = !showEmojiSelection"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>

                <button type="submit" class="chat-submit-button"></button>
            </form>
        </div>
    </div>
    <div v-else>
        <span class="chat-window-icon" @click="reopenMyChat">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                    fill-rule="evenodd"
                    d="M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97-1.94.284-3.916.455-5.922.505a.39.39 0 00-.266.112L8.78 21.53A.75.75 0 017.5 21v-3.955a48.842 48.842 0 01-2.652-.316c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97z"
                    clip-rule="evenodd"
                />
            </svg>
        </span>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed, watch } from 'vue';
import { useForm, usePage } from '@inertiajs/vue3';
import { useSound } from '@vueuse/sound';
import { useFavicon } from '@vueuse/core';
import { Chat, ChatMessage as ChatMessageType } from '@src/Chat/Pages/types';
import ChatGroup from '@src/Chat/Pages/Chat/ChatGroup.vue';
import '@src/Chat/Pages/composables/disable1Password';
import { emojis } from '@src/Chat/Pages/composables/emojis';
import { onClickOutside } from '@vueuse/core';
import axios from 'axios';
import { diffInSeconds } from '@src/Common/Helpers/dates';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

interface Props {
    chat?: Chat;
    frontend?: boolean;
    boxed?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    chat: null,
    frontend: false,
    boxed: true,
});

const chat = ref(props.chat);

const faviconType = ref('standard');

const grouped = computed(() => {
    if (!chat.value?.messages) {
        return {};
    }

    let last = null;
    return chat.value.messages.reduce((groups, item: ChatMessageType) => {
        let index = Object.values(groups).length;

        if (
            last &&
            item.user_id === last.user_id &&
            !['system', 'auto'].includes(item.type) &&
            item.type === last.type &&
            diffInSeconds(item.created_at, last.created_at) < 15 * 60
        ) {
            // keep original group
        } else {
            index++;
            groups[index] = [];
        }

        groups[index].push(item);

        last = item;
        return groups;
    }, {});
});

const initializeEcho = () => {
    if (typeof window.Echo === 'undefined') {
        window.Pusher = Pusher;

        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: import.meta.env.VITE_PUSHER_APP_KEY,
            cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
            forceTLS: true,
        });
    }
};

/**
 * Chat content
 */
const chatRefreshInterval = ref<number | null>(null);
const chatContent = ref<HTMLElement | null>(null);

const scrollToBottom = (smooth: boolean = true) => {
    chatContent.value?.scrollTo({
        top: chatContent.value.scrollHeight,
        behavior: smooth ? 'smooth' : 'instant',
    });
};

const refreshChat = () => {
    axios
        .get(props.frontend ? route('chat.my.get') : route('chat.show', { id: props.chat.id }), {
            params: {
                page_url: window.location.href,
                page_title: document.title,
            },
        })
        .then(({ data }) => {
            chat.value = data.chat;
        });
};

const { play } = useSound(route('chat.sound.beep'));

onMounted(() => {
    chatRefreshInterval.value = window.setInterval(refreshChat, 30000);

    scrollToBottom(false);

    if (props.frontend) {
        refreshChat();
    }

    // Initialize Pusher connection lazily - only when chat component is mounted
    initializeEcho();

    window.Echo.channel(`chat.${props.chat.id}`)
        .listen('.message.received', (data) => {
            if (
                data.message.chat_id === props.chat.id &&
                ((props.frontend && data.message.user_id) || (!props.frontend && !data.message.user_id))
            ) {
                addNotifications();
                play();
                refreshChat();
            }
        })
        .listen('.chat.closed', () => {
            refreshChat();
        })
        .listen('.chat.reopened', () => {
            refreshChat();
        });
});

onUnmounted(() => {
    chatRefreshInterval.value = null;

    window.Echo?.channel(`chat.${props.chat.id}`).stopListening('.message.received');
});

watch(chat, (originalValue, newValue) => {
    if (originalValue && newValue && originalValue.updated_at !== newValue.updated_at) {
        setTimeout(() => {
            scrollToBottom(true);
        }, 300);
    }
});

const environment = window.chat_params?.environment ?? usePage().props.app.env;

const faviconEnvironment = computed(() => (environment === 'production' ? 'production' : 'development'));

const faviconUrl = computed(() =>
    faviconType.value === 'standard'
        ? `themes/polygon/images/${faviconEnvironment.value}/favicon-32x32.png`
        : `themes/polygon/images/${faviconEnvironment.value}/notifications/favicon-32x32.png`,
);

useFavicon(faviconUrl, {
    baseUrl: '/',
    rel: 'icon',
});

const addNotifications = () => {
    faviconType.value = 'notifications';
};

const removeNotifications = () => {
    faviconType.value = 'standard';
};

/**
 * Submit new message
 */
const form = useForm({
    message: '',
});

const submit = () => {
    axios
        .post(route('chat.message.send'), {
            message: form.message,
            chat_id: props.chat.id,
            frontend: props.frontend,
        })
        .then(({ data }) => {
            chat.value.messages = data.chat.messages;

            form.reset();

            setTimeout(() => {
                scrollToBottom();
            }, 100);
        });
};

/**
 * Close chat
 */
const closeChat = () => {
    axios
        .post(route('chat.close'), {
            chat_id: props.chat.id,
        })
        .then(({ data }) => {
            chat.value = data.chat;
        });
};

/**
 * Reopen chat
 */
const reopenChat = () => {
    axios
        .post(route('chat.reopen'), {
            chat_id: props.chat.id,
        })
        .then(({ data }) => {
            chat.value = data.chat;
        });
};

/**
 * Minimize chat
 */
const minimizeChat = () => {
    axios
        .post(route('chat.my.minimize'), {
            chat_id: props.chat.id,
        })
        .then(({ data }) => {
            chat.value = data.chat;
        });
};

/**
 * Reopen my chat
 */
const reopenMyChat = () => {
    axios
        .post(route('chat.my.reopen'), {
            chat_id: props.chat.id,
        })
        .then(({ data }) => {
            chat.value = data.chat;
        });
};

/**
 * Make chat idle
 */
const idleChat = () => {
    axios
        .post(route('chat.idle'), {
            chat_id: props.chat.id,
        })
        .then(({ data }) => {
            chat.value = data.chat;
        });
};

/**
 * Emojis
 */
const emojiSelection = ref(null);
const showEmojiSelection = ref(false);

const inputPosition = ref(0);

onClickOutside(emojiSelection, () => {
    showEmojiSelection.value = false;
});

const updateCurrentTypingInfo = ($event: PointerEvent | KeyboardEvent) => {
    if ($event.target instanceof HTMLInputElement) {
        inputPosition.value = $event.target.selectionEnd;
    }
};

const addEmoji = (emoji: string) => {
    if (inputPosition.value === 0) {
        form.message = `${emoji} ${form.message}`;
        return;
    }

    if (inputPosition.value === form.message.length) {
        form.message = `${form.message} ${emoji}`;
        return;
    }

    const message = form.message.split('');
    message.splice(inputPosition.value, 0, emoji);
    form.message = message.join('');
};

/**
 * Label edit
 */
const labelEditing = ref(false);

const editLabel = () => {
    labelEditing.value = true;
};

const updateLabel = () => {
    labelEditing.value = false;

    axios.post(route('chat.admin.api.update', { id: chat.value.id, label: chat.value.label, _method: 'PUT' }));
};
</script>

<style scoped>
.chat-wrapper {
    background: #fff;
    border-radius: 0.25rem;
    box-shadow:
        rgba(0, 0, 0, 0.2) 0 2px 4px,
        rgba(0, 0, 0, 0.1) 0 2px 20px,
        rgba(0, 0, 0, 0.05) 0 2px 10px;
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    height: 70vh;
}

.chat-wrapper--boxed {
    height: 400px;
    min-width: 360px;
    max-width: 380px;
}

.chat-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-weight: bold;
    border-radius: 0.25rem 0.25rem 0 0;
    color: rgb(72, 50, 2);
    position: relative;
}

.chat-header--closed {
    background-color: rgb(209 213 219);
    border-top: 1px solid rgb(219 219 219);
}

.chat-header--opened,
.chat-header--frontend {
    background-color: rgb(236, 164, 6);
    border-top: 1px solid #facc15;
}

.chat-header--frontend {
    justify-content: space-between;
}

.chat-header--minimized,
.chat-header--idle {
    background-color: rgb(215, 193, 145);
    border-top: 1px solid #facc15;
}

.chat-header-button-wrapper-left {
    position: absolute;
    left: 1rem;
    transform: translate(0, -50%);
    top: 50%;
    display: flex;
}

.chat-header-button-wrapper-right {
    position: absolute;
    right: 1rem;
    transform: translate(0, -50%);
    top: 50%;
    display: flex;
}

.chat-header-button {
    width: 2rem;
    height: 2rem;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.05);
    transition: 0.3s all;
    border: 2px solid rgba(0, 0, 0, 0.15);
}

.chat-header-button:hover {
    background-color: rgba(0, 0, 0, 0.15);
}

.chat-header-icon {
    width: 1rem;
    height: 1rem;
}

.chat-info {
    flex-grow: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    box-shadow: rgba(0, 0, 0, 0.05) 0 -4px 4px;
    border-bottom: 1px solid rgb(209 213 219);
}

.chat-info-content {
    display: flex;
    align-items: center;
    font-size: 0.75rem;
    line-height: 1rem;
    color: rgb(75, 85, 99);
}

.chat-info-content > :not([hidden]) ~ :not([hidden]) {
    margin-right: -0.5rem;
    margin-left: 0.5rem;
}

.chat-info-content + .chat-info-content {
    margin-top: 0.25rem;
}

.chat-info-link {
    text-decoration: underline;
    color: #3b82f6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chat-info-link:hover {
    text-decoration: none;
}

.chat-info-icon {
    width: 0.75rem;
    height: 0.75rem;
}

.chat-content {
    padding-top: 1rem;
    padding-bottom: 0.25rem;
    padding-left: 1rem;
    padding-right: 1rem;
    overflow-y: auto;
    flex: 1 1 auto;
}

.chat-content--active {
    padding-bottom: 0.25rem;
}

.chat-content--inactive {
    padding-bottom: 1rem;
}

.chat-content > :not([hidden]) ~ :not([hidden]) {
    margin-top: 0.5rem;
}

.chat-form {
    position: relative;
    flex-grow: 0;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
}

.chat-relative {
    position: relative;
}

.chat-form-input {
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(209 213 219);
    border-radius: 0.375rem;
    width: 100%;
    appearance: none;
    background-color: #fff;
    outline: none;
}

.chat-form-input:focus {
    border-color: rgb(252 213 128);
    box-shadow: rgb(252 213 128) 0 0 3px;
}

.chat-form-input::placeholder {
    color: #9ca3af;
}

.chat-form-input:hover::placeholder {
    color: #374151;
}

.chat-emoji-button {
    position: absolute;
    z-index: 10;
    width: 1rem;
    height: 1rem;
    color: #9ca3af;
    transform: translate(-50%, -50%);
    cursor: pointer;
    user-select: none;
    top: 50%;
    right: 1rem;
}

.chat-emoji-button:hover {
    color: #4b5563;
}

.chat-emoji-window {
    position: absolute;
    min-height: 140px;
    left: 0;
    right: 0;
    bottom: 0.5rem;
    background: #fff;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-radius: 0.75rem;
    user-select: none;
    box-shadow:
        0 10px 15px -3px rgb(0 0 0 / 0.1),
        0 4px 6px -4px rgb(0 0 0 / 0.1);
    border-width: 1px;
    border-style: solid;
    border-color: #e5e7eb;
}

.chat-emoji-grid {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    list-style: none;
    margin: 0;
    padding: 0;
}

.chat-emoji-pick {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    text-align: center;
    background: #fff;
    cursor: pointer;
}

.chat-emoji-pick:hover {
    background: #f3f4f6;
}

.chat-submit-button {
    display: none;
}

.chat-responding {
    background-color: rgb(236, 164, 6);
    display: flex;
    align-items: center;
}

.chat-responding-preview {
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    flex-grow: 0;
}

.chat-responding-info {
    font-size: 0.75rem;
    padding-left: 0.25rem;
    padding-right: 1rem;
    flex: auto;
}

.chat-responding-info-offline {
    font-size: 0.75rem;
}

.chat-responding-info p {
    margin-bottom: 0;
}

.chat-responding-info-name {
    font-weight: 700;
    font-size: 0.95rem;
}

.chat-responding-avatar-wrapper {
    border-radius: 24px;
    width: 48px;
    height: 48px;
    overflow: hidden;
}

.chat-responding-avatar {
    border-radius: 24px;
    width: 48px;
    height: 48px;
    overflow: hidden;
    object-fit: cover;
}
</style>
